import { render, staticRenderFns } from "./PapercleandDocumentiMobileEditModalComponent.vue?vue&type=template&id=436af3db&scoped=true"
import script from "./PapercleandDocumentiMobileEditModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleandDocumentiMobileEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./PapercleandDocumentiMobileEditModalComponent.vue?vue&type=style&index=0&id=436af3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436af3db",
  null
  
)

export default component.exports